import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress/LinearProgress';

import { FirebaseFileUploader as FileUploader } from '@meronex/components';

import MdCameraEnhance from '@meronex/icons/md/MdCameraEnhance';

import CircularProgress from '@material-ui/core/CircularProgress';
import Annotator from './Annotator';
import Button from '@material-ui/core/Button';
import { App } from '../base/AppContext';

import { getStorage, ref } from 'firebase/storage';
import { makeStyles } from '@material-ui/core/styles';
import { utils } from '../base/utils';
import { v4 as generateRandomID } from 'uuid';

const useStyles = makeStyles((theme) => ({
  uploadBtnContainer: {
    textAlign: 'center',
    width: '100%',
  },
  uploadBtn: {
    borderRadius: '20px',
    width: '100%',
    height: '45px',
    marginTop: '5px',
    marginBottom: '25px',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
    width: 200,
  },
  formControl: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}));

export default function ImageUploader(props) {
  const [isUploading, setIsUploading] = React.useState();
  const [progress, setProgress] = React.useState(0);
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const [checkingThumb, setCheckingThumb] = React.useState(false);
  const [thumbUrl, setThumbUrl] = React.useState(undefined);
  const [imgUrl, setImgUrl] = React.useState(undefined);

  const previewContainer = props.previewContainer;

  const handleUploadStart = () => {
    if (props.onUploadStart) {
      props.onUploadStart();
    }
    setIsUploading(true);
  };
  const handleProgress = (progress) => setProgress(progress);

  const handleUploadError = (error) => {
    setIsUploading(false);
    console.error(error);
  };

  const checkThumbnail = (filename, imgUrl) => {
    utils.checkThumbnail(filename, (thumbUrl) => {
      setThumbUrl(thumbUrl);
      if (props.onUploadSuccess) {
        props.onUploadSuccess({
          imgUrl,
          thumbUrl,
        });
      }
      setCheckingThumb(false);
      setProgress(0);
    });
  };

  const handleUploadSuccess = async (filename, file) => {
    setProgress(100);
    setCheckingThumb(true);
    setIsUploading(false);

    utils.getStorageFileURL(filename, 'images', (fileUrl) => {
      // Use in memory image url, instead of
      // downloading the high resolution image.
      setImgUrl(fileUrl);

      setPreviewUrl(window.URL.createObjectURL(file));
      checkThumbnail(filename, fileUrl);
    });
  };

  const renderPreview = () => {
    return (
      <div>
        {isUploading && (
          <p>
            Uploading Image: {progress}{' '}
            <LinearProgress variant="determinate" value={progress} />
          </p>
        )}
        <div style={{ textAlign: 'center' }}>
          <div>
            {checkingThumb && (
              <div>
                <div style={{ marginBottom: '10px' }}>
                  Processing & Optimizing Image...
                </div>
                <CircularProgress />
              </div>
            )}
            {!checkingThumb && previewUrl && <Annotator src={previewUrl} />}
          </div>
        </div>
      </div>
    );
  };
  if (previewContainer && previewContainer.current) {
    ReactDOM.render(renderPreview(), previewContainer.current);
  }

  const classes = useStyles();

  const storage = getStorage(App.firebase);
  const imageRef = ref(storage, `images/${generateRandomID()}`);

  return (
    <div className={classes.uploadBtnContainer}>
      <label>
        <Button
          className={classes.uploadBtn}
          variant="outlined"
          color="primary"
          component="span"
          // className={classes.button}
        >
          <MdCameraEnhance size={20} />
          &nbsp;Add Image
        </Button>
        <FileUploader
          accept="image/*"
          name="avatar"
          randomizeFilename
          hidden
          storageRef={imageRef}
          onUploadStart={handleUploadStart}
          onUploadError={handleUploadError}
          onUploadSuccess={handleUploadSuccess}
          onProgress={handleProgress}
        />
      </label>
    </div>
  );
}

ImageUploader.propTypes = {
  previewContainer: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  onUploadStart: PropTypes.func,
  onUploadSuccess: PropTypes.func,
};
